module.exports = __webpack_public_path__ + "img/additional_highlights.png";